import { Aggregation } from '@vue-storefront/magento-api';
import { defineStore } from 'pinia';

interface FiltersState {
  filters: Aggregation[],
}

export const useFiltersStore = defineStore('filters', {
  state: (): FiltersState => ({
    filters: [],
  }),
});
